import {
  BankProductClosureRequest,
  BankProductResponse as BankPortalBankProductResponse,
} from '@b7hio/api-lib/src/bank-portal';
import { FeatureDialog, FormDatePicker } from '@b7hio/core-lib/src';
import { FormFriendly, superstructResolver } from '@b7hio/core-lib/src/form';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { create } from 'superstruct';
import {
  defaultValues,
  ProductClosureFormValidation,
} from '../ProductCloseProposalDialog/ProductClosureForm.validation';

interface Props {
  readonly open: boolean;
  readonly onClose: (event: object, reason: string) => void;
  readonly onSubmit?: (data: BankProductClosureRequest) => void;
  readonly product: BankPortalBankProductResponse;
}

export const ProductCloseDialog = ({
  open,
  onClose,
  onSubmit,
  product,
}: Props) => {
  const { t } = useTranslation(['common', 'products']);
  return (
    <FeatureDialog
      id="ProductCloseProposalDialog"
      open={open}
      title={t('products:productClosure.title')}
      onClose={onClose}>
      <ProductClosureForm onSubmit={onSubmit} />
    </FeatureDialog>
  );
};

interface ProductClosureFormProps {
  readonly onSubmit?: (data: BankProductClosureRequest) => void;
}

const ProductClosureForm = ({ onSubmit }: ProductClosureFormProps) => {
  const { t } = useTranslation(['common', 'products']);

  const { handleSubmit, control, getValues } = useForm<
    FormFriendly<BankProductClosureRequest>
  >({
    mode: 'onBlur',
    resolver: superstructResolver(ProductClosureFormValidation, {
      coerce: true,
    }),
    defaultValues: defaultValues(),
  });

  return (
    <form
      onSubmit={handleSubmit(
        async (values) => {
          const output = create(values, ProductClosureFormValidation);
          if (onSubmit) {
            await onSubmit(output);
          }
        },
        // eslint-disable-next-line no-console
        (errors) => console.log(errors, getValues())
      )}
      style={{ gridArea: 'form' }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          p: 2,
          gap: 2,
        }}>
        <Typography variant="body1">
          {t('products:productClosure.instruction')}
        </Typography>
        <FormDatePicker
          disablePast={true}
          name="closureDate"
          control={control}
          label="Closure Date"
          t={t}
          getErrorPath={(type) => t(`common:validation.date.${type}` as any)}
        />
        <Button variant="contained" type="submit">
          {t('products:productClosure.submit')}
        </Button>
      </Box>
    </form>
  );
};
